import * as store from "../../framework/customStore";
import { ITypedOption, TypedOption } from "../common/typedOption";
import {
    ownerParameterRequireWorkOrderHourBookings,
    PrivacyPolicyUrl,
    ownerParameterSetWorkOrderDurationRoundingMinutes,
    ownerParameterWorkTimeAccountTransactionDepositSalaryRowTypeCode,
    ownerParameterWorkTimeAccountTransactionWithdrawSalaryRowTypeCode,
    ownerParameterWorkTimeAccountInUse,
    optionOwnerHasStorageEnabled,
    optionOwnerHasReportingEnabled,
    ownerParameterWorkOrderOpenDialogAfterDragAndDrop,
    optionWorkShiftRoundingMinutes,
    optionWorkShiftSplitDurationMinutes,
    defaultOptionWorkShiftSplitDurationMinutes,
    defaultOptionWorkShiftRoundingMinutes,
    optionOwnerHasWorkShiftRoundingEnabled,
    optionOwnerHasTransportEnabled,
    optionOwnerHasTransportInvoicingEnabled,
    optionOwnerHasTransportNotificationsEnabled,
    optionIsFunctionsAreInUse,
    optionTransportationInvoicingFixedPriceId,
    optionOwnerHasWorkOrdersEnabled,
    optionWorkTimeVehiclesEnabled,
    optionWorkTimeApprovalModeByShift,
    optionFuusorReportingEnabled,
    optionMonitorViewEnabled,
    optionWorkTimeGroupableReportEnabled,
    OptionOwnerHasCustomOrderTypesEnabled,
    OptionOwnerHasFillingHoursCalcSettingEnabled,
    optionWorkShiftDateChangeAllowed,
    OptionOwnerUsernameMinimumLength,
    optionVehicleReportEnabled,
    OptionWorkShiftPlanningEnabled,
    OptionRoutesEnabled,
    OptionOwnerHasTransportAttachmentsEnabled,
    OptionOwnerHasEasyOppTelematicsEnabled,
} from "../common/consts";

export interface IOwnerParameters {
    getRequireWorkOrderHourBookings(): boolean;
    getPrivacyPolicy(): string;
    getWorkOrderOpenDialogAfterDragAndDrop(): boolean;
}

export class OwnerParameters implements IOwnerParameters {
    [x: string]: any;
    getParameters(): ITypedOption[] {
        const appState = store.customStore.getState();
        if (!appState || !appState.owner || !appState.owner.parameters) return [];
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-return
        return appState.owner.parameters;
    }

    getRequireWorkOrderHourBookings(): boolean {
        return TypedOption.getBooleanValue(this.getParameters(), ownerParameterRequireWorkOrderHourBookings, false);
    }

    getPrivacyPolicy(): string {
        return TypedOption.getStrValue(this.getParameters(), PrivacyPolicyUrl);
    }

    getSetWorkOrderDurationRoundingMinutes(): number {
        return TypedOption.getIntValue(this.getParameters(), ownerParameterSetWorkOrderDurationRoundingMinutes, 0);
    }

    getWorkOrderOpenDialogAfterDragAndDrop(): boolean {
        return TypedOption.getBooleanValue(this.getParameters(), ownerParameterWorkOrderOpenDialogAfterDragAndDrop, true);
    }

    //Salary
    getWorkTimeAccountInUse(): boolean {
        return TypedOption.getBooleanValue(this.getParameters(), ownerParameterWorkTimeAccountInUse, false);
    }

    getWorkTimeAccountTransactionDepositSalaryRowTypeCode(): string {
        return TypedOption.getStrValue(this.getParameters(), ownerParameterWorkTimeAccountTransactionDepositSalaryRowTypeCode);
    }

    getWorkTimeAccountTransactionWithdrawSalaryRowTypeCode(): string {
        return TypedOption.getStrValue(this.getParameters(), ownerParameterWorkTimeAccountTransactionWithdrawSalaryRowTypeCode);
    }

    static requireWorkOrderHourBookings(): boolean {
        const ownerParameters = new OwnerParameters();
        return ownerParameters.getRequireWorkOrderHourBookings();
    }

    static workOrderDurationRoundingMinutes(): number {
        const ownerParameters = new OwnerParameters();
        return ownerParameters.getSetWorkOrderDurationRoundingMinutes();
    }

    static workOrderOpenDialogAfterDragAndDrop(): boolean {
        const ownerParameters = new OwnerParameters();
        return ownerParameters.getWorkOrderOpenDialogAfterDragAndDrop();
    }

    getOwnerHasStorageEnabled(): boolean {
        return TypedOption.getBooleanValue(this.getParameters(), optionOwnerHasStorageEnabled, false);
    }

    getOwnerHasReportingEnabled(): boolean {
        return TypedOption.getBooleanValue(this.getParameters(), optionOwnerHasReportingEnabled, true);
    }
    getOptionIsFunctionsAreInUse(): boolean {
        return TypedOption.getBooleanValue(this.getParameters(), optionIsFunctionsAreInUse, false);
    }

    getOwnerHasWorkShiftRoundingEnabled(): boolean {
        return TypedOption.getBooleanValue(this.getParameters(), optionOwnerHasWorkShiftRoundingEnabled, false);
    }
    getWorkShiftSplitDurationMinutes(): number {
        return TypedOption.getIntValue(this.getParameters(), optionWorkShiftSplitDurationMinutes, defaultOptionWorkShiftSplitDurationMinutes);
    }
    getWorkShiftRoundingMinutes(): number {
        return TypedOption.getIntValue(this.getParameters(), optionWorkShiftRoundingMinutes, defaultOptionWorkShiftRoundingMinutes);
    }

    getOwnerHasTransportEnabled(): boolean {
        return TypedOption.getBooleanValue(this.getParameters(), optionOwnerHasTransportEnabled, false);
    }

    getOwnerHasTransportInvoicingEnabled(): boolean {
        return TypedOption.getBooleanValue(this.getParameters(), optionOwnerHasTransportInvoicingEnabled, false);
    }

    getOwnerHasTransportNotificationsEnabled(): boolean {
        return TypedOption.getBooleanValue(this.getParameters(), optionOwnerHasTransportNotificationsEnabled, false);
    }

    getOtionTransportationInvoicingFixedPriceId(): string {
        return TypedOption.getStrValue(this.getParameters(), optionTransportationInvoicingFixedPriceId);
    }

    getOwnerHasWorkOrdersEnabled(): boolean {
        return TypedOption.getBooleanValue(this.getParameters(), optionOwnerHasWorkOrdersEnabled, false);
    }
    getOptionWorkTimeVehiclesEnabled(): boolean {
        return TypedOption.getBooleanValue(this.getParameters(), optionWorkTimeVehiclesEnabled, false);
    }
    getOptionVehicleReportEnabled(): boolean {
        return TypedOption.getBooleanValue(this.getParameters(), optionVehicleReportEnabled, false);
    }

    getOptionWorkTimeGroupableReportEnabled(): boolean {
        return TypedOption.getBooleanValue(this.getParameters(), optionWorkTimeGroupableReportEnabled, false);
    }

    getOptionWorkTimeApprovalModeByShiftEnabled(): boolean {
        return TypedOption.getBooleanValue(this.getParameters(), optionWorkTimeApprovalModeByShift, false);
    }

    getOptionWorkShiftDateChangeAllowed(): boolean {
        return TypedOption.getBooleanValue(this.getParameters(), optionWorkShiftDateChangeAllowed, false);
    }

    getOptionFuusorReportingEnabled(): boolean {
        return TypedOption.getBooleanValue(this.getParameters(), optionFuusorReportingEnabled, false);
    }

    getOptionMonitorViewEnabled(): boolean {
        return TypedOption.getBooleanValue(this.getParameters(), optionMonitorViewEnabled, false);
    }

    getOptionCustomOrderTypesEnabled(): boolean {
        return TypedOption.getBooleanValue(this.getParameters(), OptionOwnerHasCustomOrderTypesEnabled, false);
    }

    getOptionOwnerHasFillingHoursCalcSettingEnabled(): boolean {
        return TypedOption.getBooleanValue(this.getParameters(), OptionOwnerHasFillingHoursCalcSettingEnabled, false);
    }

    getOptionOwnerUsernameMinimumLength(): number {
        return TypedOption.getIntValue(this.getParameters(), OptionOwnerUsernameMinimumLength, 8);
    }

    getOptionWorkShiftPlanningEnabled(): boolean {
        return TypedOption.getBooleanValue(this.getParameters(), OptionWorkShiftPlanningEnabled, false);
    }

    getOptionRoutesEnabled(): boolean {
        return TypedOption.getBooleanValue(this.getParameters(), OptionRoutesEnabled, false);
    }

    getOptionOwnerHasTransportAttachmentsEnabled(): boolean {
        return TypedOption.getBooleanValue(this.getParameters(), OptionOwnerHasTransportAttachmentsEnabled, false);
    }

    getOptionOwnerHasEasyOppTelematicsEnabled(): boolean {
        return TypedOption.getBooleanValue(this.getParameters(), OptionOwnerHasEasyOppTelematicsEnabled, false);
    }

}
